import safeLogo from '@cowprotocol/assets/cow-swap/safe-logo.svg'
import { SupportedChainId } from '@cowprotocol/cow-sdk'

import { t } from '@lingui/core/macro'
import styled from 'styled-components/macro'

import { SafeWalletLink } from 'common/pure/SafeWalletLink'

import { FieldLabel } from './FieldLabel'

import { Field } from '../ReceiptModal.styled'

const SafeIcon = styled.img`
  margin-right: 5px;
`

export interface SafeTxFieldsProps {
  chainId: SupportedChainId
  safeAddress: string
  safeTxHash: string
  nonce: string
  confirmations: number
  confirmationsRequired: number
}

// TODO: Add proper return type annotation
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function SafeTxFields(props: SafeTxFieldsProps) {
  const { chainId, safeAddress, safeTxHash, nonce, confirmationsRequired, confirmations } = props
  const safeTransaction = { safe: safeAddress, safeTxHash }

  const safeLogoImg = <SafeIcon src={safeLogo} alt={t`Safe logo`} />

  return (
    <>
      <Field>
        <FieldLabel label={t`Safe transaction`} tooltip={t`The hash for this Safe transaction.`} prefix={safeLogoImg} />
        <div>
          <span>{safeTxHash.slice(0, 8)}</span> {' - '}
          <SafeWalletLink chainId={chainId} safeTransaction={safeTransaction} />
        </div>
      </Field>

      <Field>
        <FieldLabel
          label={t`Safe nonce`}
          tooltip={t`Safe contracts have a so-called "nonce." This is to ensure that each transaction can be executed only once so no replay attacks are possible.`}
          prefix={safeLogoImg}
        />
        <span>{nonce}</span>
      </Field>

      <Field>
        <FieldLabel
          label={t`Safe confirmed signatures`}
          tooltip={t`The number of signers who have confirmed this transaction versus the number of signer confirmations needed.`}
          prefix={safeLogoImg}
        />
        <span>
          {confirmations} / {confirmationsRequired}
        </span>
      </Field>
    </>
  )
}
